/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

const baseUrl = 'bizops-crm-cards';
const pathParameterPlaceholder = undefined;
function freeze(value) {
  return Object.freeze(value);
}

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/bizops-crm-cards/v3/domain-assignment-events/company/{companyVid}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:CrmDomainAssignmentEventResource+type:symbol+getCrmDomainAssignmentEventsForCompanyVid&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Crm_Domain_Assignment_Event-get-%2Fbizops-crm-cards%2Fv3%2Fdomain-assignment-events%2Fcompany%2F%7BcompanyVid%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fbizops-crm-cards%2Fv3%2Fdomain-assignment-events%2Fcompany%2F%28%28%7BcompanyVid%7D%29%29?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getCrmDomainAssignmentEventsForCompanyVidRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v3/domain-assignment-events/company', pathParameterPlaceholder]),
  pathParameters: freeze(['companyVid'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/bizops-crm-cards/v3/domain-assignment-events/contact/{contactVid}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:CrmDomainAssignmentEventResource+type:symbol+getCrmDomainAssignmentEventsForContactVid&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Crm_Domain_Assignment_Event-get-%2Fbizops-crm-cards%2Fv3%2Fdomain-assignment-events%2Fcontact%2F%7BcontactVid%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fbizops-crm-cards%2Fv3%2Fdomain-assignment-events%2Fcontact%2F%28%28%7BcontactVid%7D%29%29?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getCrmDomainAssignmentEventsForContactVidRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v3/domain-assignment-events/contact', pathParameterPlaceholder]),
  pathParameters: freeze(['contactVid'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/bizops-crm-cards/v3/assignment/crm-company/{crmCompanyId}/owners
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:AssignmentResource+type:symbol+getOwner&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Assignment-get-%2Fbizops-crm-cards%2Fv3%2Fassignment%2Fcrm-company%2F%7BcrmCompanyId%7D%2Fowners'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fbizops-crm-cards%2Fv3%2Fassignment%2Fcrm-company%2F%28%28%7BcrmCompanyId%7D%29%29%2Fowners?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getOwnerRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v3/assignment/crm-company', pathParameterPlaceholder, 'owners']),
  pathParameters: freeze(['crmCompanyId'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * post-/bizops-crm-cards/v3/domain-ownership-controls/recycle/object-type/{objectType}/object-id/{vid}
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:DomainControlsOwnershipActionResource+type:symbol+recycle&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Domain_Controls_Ownership_Action-post-%2Fbizops-crm-cards%2Fv3%2Fdomain-ownership-controls%2Frecycle%2Fobject-type%2F%7BobjectType%7D%2Fobject-id%2F%7Bvid%7D'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/post/api.hubapi.com%2Fbizops-crm-cards%2Fv3%2Fdomain-ownership-controls%2Frecycle%2Fobject-type%2F%28%28%7BobjectType%7D%29%29%2Fobject-id%2F%28%28%7Bvid%7D%29%29?showRequestDetails=true&body=%7B%22ownerTypeId%22:0,%22description%22:%22string%22,%22recycleReason%22:%22string%22,%22additionalRecycleReason%22:%22string%22%7D&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const recycleRpc = freeze({
  baseUrl,
  method: 'post',
  pathSegments: freeze(['v3/domain-ownership-controls/recycle/object-type', pathParameterPlaceholder, 'object-id', pathParameterPlaceholder]),
  pathParameters: freeze(['objectType', 'vid'])
});